const  DateConvert =(CreateDate)=>{
    const originalDate = CreateDate || '';
    const FormatedDate = originalDate?.slice(0,10);
    const FormatedTime = originalDate?.slice(11,19);
    
    return (FormatedDate+' '+FormatedTime)
}

export default DateConvert;